// extracted by mini-css-extract-plugin
export var iconLink = "IconGroup-module--iconLink--705d0";
export var icongroup = "IconGroup-module--icongroup--430a4";
export var text = "IconGroup-module--text--daaa5";
export var title = "IconGroup-module--title--775bb";